import {DesignerTab} from "../../constants/designerTab";

const TabsData: Partial<Record<DesignerTab, null | string>> = {
    [DesignerTab.author]: 'authorTopProjectsFilter',
}

export const getTagProjectFilter = (tabName: DesignerTab, filters: any): any => {

    // пока что облако тегов только на авторе будет
    if (TabsData[tabName] === null || tabName !== DesignerTab.author) return null;

    const filter = filters[TabsData[tabName] || ''];

    if (!filter) return null;

    let newFilter = {};
    for (const key of Object.keys(filter)) {
        if (filter[key] !== undefined) newFilter = {...newFilter, [key]: filter[key]}
    }
    newFilter = {...newFilter, onlyEnucationTags: true, tagIds: []}
    if (tabName == DesignerTab.author) newFilter = {...newFilter, projectStatus: [1], isContextIgnored: false, contexts: 'hsedesign', projectFilter: 1}

    return newFilter || null;
}import {DesignerTab} from "../../constants/designerTab";

const TabsData: Partial<Record<DesignerTab, null | string>> = {
    [DesignerTab.author]: 'authorTopProjectsFilter',
}

export const getTagProjectFilter = (tabName: DesignerTab, filters: any): any => {

    // пока что облако тегов только на авторе будет
    if (TabsData[tabName] === null || tabName !== DesignerTab.author) return null;

    const filter = filters[TabsData[tabName] || ''];

    if (!filter) return null;

    let newFilter = {};
    for (const key of Object.keys(filter)) {
        if (filter[key] !== undefined) newFilter = {...newFilter, [key]: filter[key]}
    }
    newFilter = {...newFilter, onlyEnucationTags: true, tagIds: []}
    if (tabName == DesignerTab.author) newFilter = {...newFilter, projectStatus: [1], isContextIgnored: false, contexts: 'hsedesign', projectFilter: 1}

    return newFilter || null;
}